import React from "react"
import { Box, Heading, Image, Spacer, Text, Stack } from "@chakra-ui/react"
import datasetCard from "../images/dataset-card.svg"
import { DatasetSchemas } from "../lib/store"
import Link from "./Link"

const cardStyles = {
  bg: "Gray.100",
  w: 48,
  minH: 48,
  borderRadius: "lg",
  boxShadow: "lg",
  overflow: "hidden",
}

const cardHeaderStyles = {
  display: "flex",
  bg: "Gray.700",
  p: 3,
  h: 28,
  justifyContent: "center",
  alignItems: "center",
}

export default function DatasetCard({ dataset }) {
  const [datasetSchemas] = DatasetSchemas.useState()
  const count = React.useMemo(
    () => datasetSchemas[dataset.id]?.length || 0,
    [datasetSchemas, dataset],
  )

  return (
    <Box {...cardStyles}>
      <Box {...cardHeaderStyles}>
        <Image boxSize="90px" src={datasetCard} />
      </Box>
      <Stack p={3} gap={0} flexGrow={1}>
        <Heading
          fontSize="sm"
          overflow="hidden"
          textOverflow="ellipsis"
          whiteSpace="nowrap"
        >
          <Link to={`/datasets/${dataset.id}`}>{dataset.name}</Link>
        </Heading>
        <Text
          overflow="hidden"
          textOverflow="ellipsis"
          fontSize="xs"
          noOfLines={2}
        >
          {dataset.description}
        </Text>
        <Spacer />
        <Text variant="card">
          {count} schema{count > 1 ? "s" : ""}
        </Text>
      </Stack>
    </Box>
  )
}
